import createAxiosInstance from '../../../api';
import { useAlert } from '../../../components/Notification';
import { useDispatch } from 'react-redux';
import { setCustomerInformationAction } from '../../../stores/actionTypes/profileManagementActions';
import { useNavigate } from 'react-router-dom';

export function useHook() {
  const axiosInstance = createAxiosInstance();
  const showAlert = useAlert();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchCustomerInfo = async () => {
    let data = null;
    await axiosInstance
      .get('/customers/customerInfo')
      .then((response) => {
        dispatch(setCustomerInformationAction(response?.data?.data));
        data = response?.data;
      })
      .catch((error) => {
        dispatch(setCustomerInformationAction({}));
        showAlert(error?.response?.data?.error || error?.message, 'warning');
        data = error?.response?.data;
      });
    return data;
  };

  const updateCustomerInfo = async (payload) => {
    await axiosInstance
      .post('/customers/updateCustomerInfo', payload)
      .then(() => {
        showAlert('CustomerInformation updated successfully', 'success');
      })
      .catch(() => {
        showAlert('Failed to CustomerInformation updated', 'warning');
      });
  };

  const updateCustomerOrgInfo = async (payload) => {
    await axiosInstance
      .post('/customers/updateCustomerOrgInfo', payload)
      .then(() => {
        showAlert('Organization updated successfully', 'success');
      })
      .catch(() => {
        showAlert('Failed to Organization updated', 'warning');
      });
  };

  const updateCustomerNotificationPref = async (payload) => {
    await axiosInstance
      .post('/customers/updateCustomerNotificationPref', payload)
      .then(() => {
        showAlert('NotificationPreference updated successfully', 'success');
      })
      .catch(() => {
        showAlert('Failed to NotificationPreference updated', 'warning');
      });
  };

  const updateInfoOTP = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/customers/updateInfoOTP', payload)
      .then((response) => {
        data = response?.data;
        // showAlert('CustomerInformation updated successfully', 'success');
      })
      .catch(() => {
        // showAlert('Failed to CustomerInformation updated', 'warning');
      });
    return data;
  };

  const verifyInfoOTP = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/customers/verifyInfoOTP', payload)
      .then((response) => {
        data = response?.data;
        showAlert('CustomerInformation verifyed successfully', 'success');
      })
      .catch(() => {
        showAlert('Failed to CustomerInformation verifyed', 'warning');
      });
    return data;
  };

  return {
    fetchCustomerInfo,
    updateCustomerInfo,
    updateCustomerOrgInfo,
    updateCustomerNotificationPref,
    updateInfoOTP,
    verifyInfoOTP,
  };
}
